export default __webpack_public_path__ + "static/media/emily.a0d6d13a.jpg";